import BrowserChrome from './BrowserChrome';

/**
 * ViennaAfter — illustration based on the real redesign at
 * viennaaquariumandpets.com. The descriptive tiles at the bottom
 * (species count, rating, years in business) are facts about the
 * store itself, publicly visible on-site and on review platforms —
 * not performance metrics claimed by WebNova.
 */
export default function ViennaAfter() {
  return (
    <BrowserChrome url="viennaaquariumandpets.com" dark>
      <div
        className="modern"
        style={{
          background: 'radial-gradient(1000px 600px at 20% 0%,#0e2a1e 0%,#05110c 55%)',
        }}
      >
        <div className="m-nav">
          <div className="b" style={{ color: '#d4f5e4' }}>
            {/* Pet-store brand gradient (mint→aqua) — intentionally in the
                aquarium family, not the WebNova palette, because this mock
                represents Vienna's own identity. */}
            <i style={{ background: 'linear-gradient(135deg,#6ee7b7,#a7f3d0)' }} />
            Vienna Aquarium
          </div>
          <div className="l">
            <span>Live animals</span>
            <span>Supplies</span>
            <span>Visit us</span>
          </div>
          <div className="c" style={{ background: '#6ee7b7', color: '#05110c' }}>
            Directions →
          </div>
        </div>
        <div className="m-hero">
          <div>
            <h2 style={{ color: '#e8f5ec' }}>
              The pet store that <em style={{ color: '#6ee7b7' }}>still knows you</em> by name.
            </h2>
            <p>
              Family-owned in Vienna since 2005. Come see fish, reptiles, and small pets — plus the
              expert advice that made us a neighborhood staple.
            </p>
            <div className="row">
              <span className="chip fill" style={{ background: '#6ee7b7', color: '#05110c' }}>
                Plan your visit →
              </span>
              <span className="chip">Shop supplies</span>
            </div>
          </div>
          <div className="m-card" style={{ background: 'linear-gradient(160deg,#0c3224,#051911)' }}>
            <div className="fishy">
              <svg viewBox="0 0 100 100">
                <defs>
                  <linearGradient id="fg2">
                    <stop offset="0" stopColor="#6ee7b7" />
                    <stop offset="1" stopColor="#4dd4e3" />
                  </linearGradient>
                </defs>
                <path
                  d="M20 50 Q40 20 70 50 Q40 80 20 50 Z M70 50 L90 35 L90 65 Z"
                  fill="url(#fg2)"
                />
                <circle cx="35" cy="45" r="2" fill="#05110c" />
              </svg>
            </div>
          </div>
        </div>
        <div className="m-grid">
          <div className="m-tile">
            <b>
              Fish, reptiles,<span> small pets</span>
            </b>
            under one roof
          </div>
          <div className="m-tile">
            <b>Local</b>family-owned since 2005
          </div>
          <div className="m-tile">
            <b>Visit</b>hours &amp; directions
          </div>
        </div>
        <div className="m-foot">
          <span>Mon–Fri 10–8 · Sat 10–7</span>
          <span>Built by WebNova</span>
        </div>
      </div>
    </BrowserChrome>
  );
}
